import { render } from "./TemplatesView.vue?vue&type=template&id=ca4ebf74&scoped=true"
import script from "./TemplatesView.vue?vue&type=script&lang=js"
export * from "./TemplatesView.vue?vue&type=script&lang=js"

import "./TemplatesView.vue?vue&type=style&index=0&id=ca4ebf74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4ebf74"]])

export default __exports__